import QuizNavigation from './QuizNavigation'
import QuizCountdownTimer from './QuizCountdownTimer'
import { useDispatch } from 'react-redux'

const QuizHeader = (props) => {
	const dispatch = useDispatch()

	return (
		<div className='dFlex itemsCenter justifyBetween md-flexCol '>
			{props.quizTimer && props.quizCount !== 0 ? (
				<QuizCountdownTimer
					onEndCount={() => dispatch(props.onEndCount())}
					setQuizTimer={(count) => dispatch(props.setQuizTimer(count))}
					onUnmount={(count) => dispatch(props.onUnmount(count))}
					quizCount={props.quizCount}
				/>
			) : null}
			<div>
				<QuizNavigation {...props} />
			</div>
		</div>
	)
}

export default QuizHeader